<app-entity-mat-dialog-title title="Edit Incident Banner Message"></app-entity-mat-dialog-title>

<div mat-dialog-content>
  <mat-form-field appearance="outline" class="incident-edit-field">
    <mat-label>Message shown to all users</mat-label>
    <textarea
      matInput
      [(ngModel)]="draft"
      rows="6"
    ></textarea>
  </mat-form-field>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
